import { fromUnixTime, getUnixTime } from "date-fns/esm";

import { ScheduledDelete, ScheduledDeleteInput } from "types/generated";

import { StackManageScheduledDeleteFormFields } from "./types";

export const getFormDefaultValues = (
  defaultDateTime?: Date,
  integration?: ScheduledDelete
): StackManageScheduledDeleteFormFields => {
  try {
    return {
      shouldDeleteResources: integration?.shouldDeleteResources ?? false,
      dateTime: integration?.timestampSchedule
        ? fromUnixTime(integration.timestampSchedule)
        : defaultDateTime,
      timezoneDisplay: "local",
    };
  } catch {
    return {
      shouldDeleteResources: false,
      dateTime: undefined,
      timezoneDisplay: "local",
    };
  }
};

export const mapCreateFormData = (
  values: StackManageScheduledDeleteFormFields
): ScheduledDeleteInput | undefined => {
  if (!values.dateTime) {
    return undefined;
  }

  try {
    return {
      shouldDeleteResources: values.shouldDeleteResources,
      timestampSchedule: getUnixTime(values.dateTime),
      cronSchedule: null,
      timezone: null,
    };
  } catch {
    return undefined;
  }
};
